import React from 'react';
import classnames from 'classnames/bind';
import styles from './infoDetailArticleMain.module.scss';

const cx = classnames.bind(styles);

interface IInfoDetailArticleMainProps {
  content: string;
}

const InfoDetailArticleMain: React.FC<IInfoDetailArticleMainProps> = ({ content }) => {
  const innerHTML = content
    .replace(/font-size: 13pt/gi, 'font-size: 17px; color: rgb(106, 106, 106)')
    .replace(/font-size: 15pt/gi, 'font-size: 20px; font-weight: bold; line-height: 30px; color: rgb(71, 71, 71)');

  return (
    <div
      className={cx('content')}
      dangerouslySetInnerHTML={{
        __html: innerHTML,
      }}
    />
  );
};

export default InfoDetailArticleMain;
